export default __webpack_public_path__ + "static/media/SFProText-Heavy-1.a6d0a7c7.ttf";